export default __webpack_public_path__ + "static/media/Appstorebadge.8c4986ee.svg";